export default "__VITE_ASSET__CqrOnJtM__"